import { Analysis, PossibleRootCauseCategory } from '.';

export class GlucoseAnalysis extends Analysis {
    calculateInsights() {
        if (this.ba.glucose.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6000);
        } else if (this.ba.glucose.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6010);
        }

        if (this.ba.hemoglobinA1c.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6020);
        } else if (this.ba.hemoglobinA1c.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6030);
        }

        if (this.ba.insulin.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6040);
        } else if (this.ba.insulin.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6050);
        }

        if (this.ba.cpeptide.isGreaterThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6060);
        } else if (this.ba.cpeptide.isStricklyLessThanOptimal()) {
            this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6070);
        }

        if (
          this.ba.triglycerides.isGreaterThanOptimal() &&
          this.ba.triglyceridesHDLRatio.isLessThanOrIsOptimal()
        ) {
          this.possibleRootCauseCategories.push(
            PossibleRootCauseCategory.CATEGORY_6075,
          );
        } else if (
          this.ba.triglycerides.isGreaterThanOptimal() &&
          this.ba.triglyceridesHDLRatio.isGreaterThanOptimal()
        ) {
          this.possibleRootCauseCategories.push(
            PossibleRootCauseCategory.CATEGORY_6076,
          );
        } else if (
          this.ba.triglycerides.isLessThanOrIsOptimal() &&
          this.ba.triglyceridesHDLRatio.isGreaterThanOptimal()
        ) {
          this.possibleRootCauseCategories.push(
            PossibleRootCauseCategory.CATEGORY_6077,
          );
        }

        if (this.ba.amylase.isGreaterThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6080);
        }

        if (this.ba.amylase.isGreaterThanLab()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6085);
        }

        if (this.ba.amylase.isLessThanOptimal()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6090);
        }

        if (this.ba.amylase.isLessThanLab()) {
        this.possibleRootCauseCategories.push(PossibleRootCauseCategory.CATEGORY_6091);
        }

    }
}